import React from 'react';

import {ApproveButton} from 'app/procedures/components/page-headers/RequestOrApproveButton/ApproveButton';
import {RequestApprovalButton} from 'app/procedures/components/page-headers/RequestOrApproveButton/RequestApprovalButton/RequestApprovalButton';

import type {BasicUserSerializedType, DocumentContentType} from 'sweet-types';
type Props = {
  contentType: DocumentContentType;
  documentId: number | string;
  versionId: number | string;
  documentHtmlURL: string;
  versionURL: string;
  managers: Array<BasicUserSerializedType>;
  className?: string;
  canApprove: boolean;
  disabled: boolean;
  versionApprovedAt: string | null;
  versionIsCurrent?: boolean;
  refreshData?: () => unknown;
  onApprovalRequest?: (
    requestApproveFunction: () => Promise<any>
  ) => Promise<any>;
  isDropDown?: boolean;
  onApprove?: (approveFunction: () => Promise<any>) => Promise<any>;
  nextReviewDate: string | null;
};

const RequestOrApproveButton = ({
  canApprove,
  contentType,
  documentId,
  versionId,
  versionURL,
  versionApprovedAt,
  versionIsCurrent,
  onApprovalRequest,
  onApprove,
  disabled = false,
  managers,
  documentHtmlURL,
  refreshData,
  nextReviewDate,
  className,
  isDropDown,
}: Props) => {
  const currentAndApproved = Boolean(
    versionApprovedAt != null && versionIsCurrent === true
  );

  return canApprove ? (
    <ApproveButton
      disabled={disabled || currentAndApproved}
      contentType={contentType}
      documentId={documentId}
      documentHtmlURL={documentHtmlURL}
      versionURL={versionURL}
      onApprove={onApprove}
      versionApprovedAt={versionApprovedAt}
      versionId={versionId}
      onApprovalRequest={onApprovalRequest}
      managers={managers}
      refreshData={refreshData}
      nextReviewDate={nextReviewDate}
      className={className}
      isDropDown={isDropDown}
    />
  ) : (
    <RequestApprovalButton
      disabled={disabled || currentAndApproved}
      contentType={contentType}
      versionId={versionId}
      onApprovalRequest={onApprovalRequest}
      versionApprovedAt={versionApprovedAt}
      managers={managers}
      refreshData={refreshData}
      className={className}
    />
  );
};

export default RequestOrApproveButton;
